import React from 'react'
import PropTypes from 'prop-types'
import FormattedCheckbox from '../FormattedCheckbox'
import HelpButton from '../HelpButton'

const CheckboxWithHelp = ({ children, onClick, checked, helpOnClick, wrapperClassName, labelClassName, disabled }) => (
  <div className={`flex items-center ${wrapperClassName}`}>
    <button
      id="insuranceCancellation"
      name="insuranceCancellation"
      type="button"
      onClick={onClick}
      disabled={disabled}
      // value={insuranceCancellation === 'true' ? 'false' : 'true'}
      className={`flex text-sm items-center focus:outline-none mt-0
        ${checked ? 'text-harbor' : 'text-grey-dark'}
        ${disabled ? 'opacity-50' : ''}
        ${labelClassName}
      `}
    >
      <FormattedCheckbox className="ml-0 sm:ml-2 mr-3 sm:mr-6" checked={checked} disabled={disabled} />
      {children}
    </button>

    {helpOnClick && (
      <HelpButton
        onClick={helpOnClick}
        classNameAppend="ml-3 sm:ml-6"
      />

      // <div className="flex-grow">
      //   <button
      //     type="button"
      //     onClick={helpOnClick}
      //     className="rounded-full font-bold w-6 h-6 bg-sky flex items-center justify-center text-white ml-3 sm:ml-6 text-sm focus:outline-none"
      //   >
      //     i
      //   </button>
      // </div>
    )}
  </div>
)

CheckboxWithHelp.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  onClick: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  helpOnClick: PropTypes.func,
  wrapperClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  disabled: PropTypes.bool
}

CheckboxWithHelp.defaultProps = {
  checked: false,
  helpOnClick: null,
  wrapperClassName: '',
  labelClassName: '',
  disabled: false
}

export default CheckboxWithHelp